import { useParams, useLocation, Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { fcfa } from "../../lib/format";
import { ShopHeader } from "../../components/shop/ShopHeader";

export default function Confirmation() {
  const { orderNumber } = useParams();
  const { state } = useLocation();

  return (
    <div className="App overflow-x-hidden min-h-screen bg-brand-cream">
      <ShopHeader />
      <div className="max-w-md mx-auto px-4 py-16 text-center">
        <div className="bg-white border border-brand-line rounded-3xl p-10 shadow-sm">
          <CheckCircle2 className="w-16 h-16 text-brand-accent mx-auto mb-4" />
          <h1 className="font-heading text-2xl font-black text-brand-ink">Commande confirmée !</h1>
          <p className="text-brand-sub mt-3">
            Merci pour votre confiance. Votre commande <span className="font-semibold text-brand-ink" data-testid="order-number">{orderNumber}</span> a bien été enregistrée.
          </p>
          {state?.total != null && (
            <p className="mt-2 font-heading font-bold text-lg text-brand">{fcfa(state.total)}</p>
          )}
          <p className="text-sm text-brand-muted mt-4">
            Nous vous contacterons par téléphone/WhatsApp pour finaliser votre commande.
          </p>
          <Link to="/boutique" className="mt-8 inline-block bg-brand text-white hover:bg-brand-hover transition-colors rounded-full px-6 py-3 font-semibold">
            Retour à la boutique
          </Link>
        </div>
      </div>
    </div>
  );
}
